import flagsmith from 'flagsmith';
import React from 'react';
import { Provider } from 'react-redux';
import { MixpanelProvider } from 'react-mixpanel-browser';
import configureStore from './store/configureStore';
import { PersistGate } from 'redux-persist/integration/react';
import '@fontsource/assistant';
import './stylesheets/css/cymbio-ic/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './stylesheets/scss/custom-media-grid.scss';
import './stylesheets/scss/retailers-media-grid.scss';
import './stylesheets/scss/media-grid-products.scss';
import './stylesheets/scss/brands-replenish-media-grid.scss';
import './stylesheets/css/scrollbar.css';
import './stylesheets/css/fonts.css';
import 'react-tagsinput/react-tagsinput.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import 'react-phone-number-input/style.css';
import './stylesheets/scss/App.scss';
import LocalGTMProvider from './containers/common/LocalGTMProvider';
import IsMobile from './containers/common/IsMobile';
import { CymbioSpinner } from './components/common/Spinner';
import { FlagsmithProvider } from 'flagsmith/react';
import useCookie from './hooks/useCookie';
import { CYMBIO_AUTOMATION_COOKIE } from './constants/mainConstants';
import { FlagsmithIdentity } from './containers/common/FlagsmithIdentity';
import { AppLoader } from './containers/common/AppLoader';
import { MobileNotSupported } from './components/layouts/MobileNotSupported';
import { AppError } from './components/layouts/AppError';
import { FLAGSMITH_TTL } from './constants/featureFlag';

const flagsmithEnvironment = process.env.REACT_APP_FLAGSMITH_API_TOKEN || '';

export default function App() {
  const { store, persistor } = configureStore();
  const { hasCookie } = useCookie();

  if (!flagsmithEnvironment) {
    console.error('REACT_APP_FLAGSMITH_API_TOKEN is not set or is empty');
    return <AppError />;
  }

  const flagsmithOptions = {
    environmentID: flagsmithEnvironment,
    preventFetch: hasCookie(CYMBIO_AUTOMATION_COOKIE),
    cacheFlags: true,
    cacheOptions: {
      ttl: FLAGSMITH_TTL,
    },
  };

  return (
    <LocalGTMProvider>
      <Provider store={store}>
        <MixpanelProvider>
          <FlagsmithProvider flagsmith={flagsmith} options={flagsmithOptions}>
            <FlagsmithIdentity>
              <PersistGate loading={<CymbioSpinner shouldCenterVerticallyInViewport />} persistor={persistor}>
                <IsMobile desktop={<AppLoader />} mobile={<MobileNotSupported />} />
              </PersistGate>
            </FlagsmithIdentity>
          </FlagsmithProvider>
        </MixpanelProvider>
      </Provider>
    </LocalGTMProvider>
  );
}
